import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=84dd9e04"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"
import style0 from "./ScrollTop.vue?vue&type=style&index=0&id=84dd9e04&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-admin-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84dd9e04')) {
      api.createRecord('84dd9e04', component.options)
    } else {
      api.reload('84dd9e04', component.options)
    }
    module.hot.accept("./ScrollTop.vue?vue&type=template&id=84dd9e04", function () {
      api.rerender('84dd9e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scroll-top/ScrollTop.vue"
export default component.exports